var render = function render(){var _vm=this,_c=_vm._self._c;return _c('viewer',{attrs:{"disabled":_vm.type}},[_c('img',{staticStyle:{"cursor":"pointer"},style:(_vm.css),attrs:{"src":_vm.src},on:{"error":function($event){return _vm.errorImg($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }